const Loader = () => {
  return (
    <div className="flex items-center justify-center h-40">
      <div className="relative flex items-center justify-center">
        <div className="absolute w-12 h-12 bg-red-500 rounded-full animate-ping opacity-75"></div>
        <div className="relative w-8 h-8 bg-red-600 rounded-full shadow-lg"></div>
      </div>
    </div>
  );
};

export default Loader
